import { Http, Headers } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";
var UsersService = (function () {
    function UsersService(http, appService) {
        this.http = http;
        this.appService = appService;
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }
    UsersService.prototype.getUsersList = function (filterParams) {
        var url = this.apiUrl + 'api/cms/user/list';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(filterParams);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    UsersService.prototype.createUser = function (data) {
        var url = this.apiUrl + 'api/cms/user/create';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.post(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    UsersService.prototype.editUser = function (data) {
        var url = this.apiUrl + 'api/cms/user/edit';
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        var body = JSON.stringify(data);
        return this.http.put(url, body, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    UsersService.prototype.deleteUser = function (id) {
        var url = this.apiUrl + 'api/cms/user/delete/' + id;
        var headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.delete(url, { headers: headers })
            .toPromise()
            .then(function (res) { return res.json(); })
            .then(function (resJson) { return resJson; });
    };
    return UsersService;
}());
export { UsersService };



// WEBPACK FOOTER //
// /build/client-cms/src/app/users/users.service.ts.pre-build-optimizer.js